webpackJsonp([4],{

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = __webpack_require__(159);

var _components = __webpack_require__(753);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Process = function Process() {
  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(
      _reactHelmet.Helmet,
      null,
      _react2.default.createElement(
        "title",
        null,
        " Process - afrodesiamedia "
      ),
      _react2.default.createElement("link", { rel: "shortcut icon", href: "/favicon.ico" }),
      _react2.default.createElement("meta", { property: "og:type", content: "company" }),
      _react2.default.createElement("meta", { property: "og:url", content: "https://www.afrodesiamedia.com/process" }),
      _react2.default.createElement("meta", { property: "og:title", content: "Process" })
    ),
    _react2.default.createElement(_components.ProcessPage, null)
  );
};

exports.default = Process;

/***/ }),

/***/ 753:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LineContent = exports.ProcessPage = undefined;

var _ProcessPage = __webpack_require__(772);

var _ProcessPage2 = _interopRequireDefault(_ProcessPage);

var _LineContent = __webpack_require__(773);

var _LineContent2 = _interopRequireDefault(_LineContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ProcessPage = _ProcessPage2.default;
exports.LineContent = _LineContent2.default;

/***/ }),

/***/ 772:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _ = __webpack_require__(753);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// import ScrollAnimation from 'react-animate-on-scroll'


var ProcessPage = function (_Component) {
  _inherits(ProcessPage, _Component);

  function ProcessPage() {
    _classCallCheck(this, ProcessPage);

    return _possibleConstructorReturn(this, (ProcessPage.__proto__ || Object.getPrototypeOf(ProcessPage)).apply(this, arguments));
  }

  _createClass(ProcessPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
          'div',
          { className: 'Process' },
          _react2.default.createElement(
            'section',
            { className: 'pro-masthead' },
            _react2.default.createElement(
              'div',
              { className: 'container' },
              _react2.default.createElement(
                'div',
                { className: 'row center-xs' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-xs-6' },
                  _react2.default.createElement(
                    'div',
                    { className: 'box' },
                    _react2.default.createElement(
                      'h1',
                      null,
                      'At afrodesiamedia our process begins with the following..'
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(_.LineContent, null)
        )
      );
    }
  }]);

  return ProcessPage;
}(_react.Component);

exports.default = ProcessPage;

/***/ }),

/***/ 773:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(108);

var _macScreen = __webpack_require__(774);

var _macScreen2 = _interopRequireDefault(_macScreen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import SearchBar from '../../../includes/Forms/SearchBar'

var LineContent = function LineContent() {
	return _react2.default.createElement(
		_react.Fragment,
		null,
		_react2.default.createElement(
			'section',
			{ className: 'LineContent' },
			_react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'article',
					{ className: 'container' },
					_react2.default.createElement(
						'div',
						{ className: 'row center-xs' },
						_react2.default.createElement(
							'div',
							{ className: 'col-xs-6' },
							_react2.default.createElement(
								'div',
								{ className: 'box' },
								_react2.default.createElement('img', { className: 'img', src: _macScreen2.default, width: '300' }),
								_react2.default.createElement(
									'h3',
									null,
									'Understanding what experience the user could take on going to the relevant desired areas of the website.'
								)
							)
						)
					)
				),
				_react2.default.createElement(
					'article',
					{ className: 'container' },
					_react2.default.createElement(
						'div',
						{ className: 'row center-xs' },
						_react2.default.createElement(
							'div',
							{ className: 'col-xs-6' },
							_react2.default.createElement(
								'div',
								{ className: 'box' },
								_react2.default.createElement(
									'h3',
									null,
									'Design Process'
								),
								_react2.default.createElement(
									'p',
									null,
									'Starts with crafting ideas that will help fuel the visual communication process.'
								)
							)
						)
					)
				),
				_react2.default.createElement(
					'article',
					{ className: 'container' },
					_react2.default.createElement(
						'div',
						{ className: 'row center-xs' },
						_react2.default.createElement(
							'div',
							{ className: 'col-xs-6' },
							_react2.default.createElement(
								'div',
								{ className: 'box' },
								_react2.default.createElement(
									'h3',
									null,
									'User Flow'
								),
								_react2.default.createElement(
									'p',
									null,
									'This is where we begin the actual important communication mechanism towards guiding the user to desired locations and areas of interest.'
								)
							)
						)
					)
				),
				_react2.default.createElement(
					'article',
					{ className: 'container' },
					_react2.default.createElement(
						'div',
						{ className: 'row center-xs' },
						_react2.default.createElement(
							'div',
							{ className: 'col-xs-6' },
							_react2.default.createElement(
								'div',
								{ className: 'box' },
								_react2.default.createElement(
									'h3',
									null,
									'Content Shaping '
								),
								_react2.default.createElement(
									'p',
									null,
									'Starts with crafting ideas that will help fuel the visual communication process.'
								)
							)
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'getstart' },
					_react2.default.createElement(
						_reactStatic.Link,
						{ to: '/getting-started', className: 'getting-started' },
						'start your project today!'
					)
				)
			)
		)
	);
};
// import ScrollAnimation from 'react-animate-on-scroll'
exports.default = LineContent;

/***/ }),

/***/ 774:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ })

});


// WEBPACK FOOTER //
// templates/src/pages/Process/Process.889aa7e5.js